import { render, staticRenderFns } from "./SugestaoFidelize.vue?vue&type=template&id=542162e2&scoped=true"
import script from "./SugestaoFidelize.vue?vue&type=script&lang=js"
export * from "./SugestaoFidelize.vue?vue&type=script&lang=js"
import style0 from "./SugestaoFidelize.vue?vue&type=style&index=0&id=542162e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542162e2",
  null
  
)

export default component.exports